import { environment as defaultEnvironment } from './environment.vmdefaults';

export const environment = {
  ...defaultEnvironment,
  production: true,
  hmr: false,
  getTokenUrl: '/sitecoreapi/spa/digest',
  graphQLUrl: '/sitecoreapi/graphql/publiek?sc_apikey=F000EF8E-32A5-4846-A783-5F70F70C2008',
  availableVMModulesUrl: '/apiproxy/veiligheidsmeter/veiligheidsmeter/ophalenbeschikbaremodules',
  vmModuleUrl: '/apiproxy/veiligheidsmeter/veiligheidsmeter/ophalenmodule',
  vmStoreVMUrl: '/apiproxy/veiligheidsmeter/veiligheidsmeter/opslaanveiligheidsmeter',
  vmGetScore: '/apiproxy/veiligheidsmeter/veiligheidsmeter/ophaleningevuldemodule'
};
